import { handleOpenChat } from "utils/analytics";

export default function About() {
  return (
    <div className="flex items-center flex-col flex-wrap p-10">
      <img src="/logo.png" className="h-40" alt="Meu Caribe" />
      <h3 className="text-center p-5 text-2xl font-light">A sua agência de passeios em Maragogi</h3>
      <p className="text-center">
          Ir ao destino sem ter um guia experiente pode ser frustante, mas agendando conosco isso não acontece.<br/>
          Todos os nossos profissionais são nativos da região com decadas de experiência.<br/>
          Aqui você não corre riscos.
      </p>
      <button onClick={handleOpenChat} type="button" className="text-white bg-blue-500 py-2 px-5 rounded mt-5">
        Fale Conosco
      </button>
    </div>
  )
}